<template>
    <div class="my-textarea" :class="{ 'is-focus ': showFocusMode }">
        <textarea
            v-model="current_value"
            ref="textarea"
            :rows="rows"
            :name="name"
            class="form-control"
            :class="additionalClass"
            :placeholder="current_placeholder"
            :disabled="disabled"
            @input="onInput"
            @focus="onFocus"
            @blur="onBlur"
        >
        </textarea>

        <div
            class="my-textarea-label"
            :class="{ 'font-weight-bold ': showFocusMode }"
            @click="$refs.textarea.focus()"
        >
            {{ label }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        additionalClass: {
            type: String,
            required: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        label: {
            type: String,
            required: false,
        },

        name: {
            type: String,
            required: false,
        },

        placeholder: {
            type: String,
            required: false,
        },

        rows: {
            type: Number,
            default: 4,
        },

        value: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            current_placeholder: this.placeholder,
            current_value: this.value,
            is_focus: false,
        }
    },

    computed: {
        showFocusMode() {
            return this.is_focus || this.value || this.placeholder
        },
    },

    watch: {
        placeholder() {
            this.value = ''

            this.current_placeholder = this.placeholder
        },

        value(newValue) {
            this.current_value = newValue
        },
    },

    methods: {
        checkFocus() {
            if(! this.current_value) {
                this.is_focus = false
            }
        },

        onBlur() {
            this.is_focus = false

            this.$emit('blur')
        },

        onFocus() {
            this.is_focus = true
            this.current_placeholder = ''

            this.$emit('focus')
        },

        onInput() {
            this.checkFocus()

            this.$emit('input', this.current_value)
        },
    },
}
</script>

<style lang="sass" scoped>
    .my-textarea
        position: relative

        .my-textarea-label
            position: absolute
            top: 0
            left: 0
            line-height: 3rem
            margin-left: .75rem
            color: grey
            transition: all .2s

        &.is-focus
            textarea
                padding-top: 1.3rem

            .my-textarea-label
                top: 0.5rem
                font-size: 0.75rem
                border-radius: 5px
                height: auto
                line-height: 1
</style>